import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
    selector: 'shared-ui-inputs-form-error',
    templateUrl: './form-error.component.html',
    styleUrls: ['./form-error.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormErrorComponent {
  errorMessages = new Array<string>();
  hideComponent = false;

  @Input() public set hide(value: boolean) {
    this.hideComponent = value;
    this.changeDetector.detectChanges();
  }

  @Input() public set texts(value: string[]) {
    if (this.errorMessages.length === value.length && this.errorMessages.every((val) => value.includes(val))) {
      return;
    }

    this.errorMessages = value;
    this.changeDetector.detectChanges();
  }

  public constructor(private changeDetector: ChangeDetectorRef) {}
}
